import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    INotificationSettings,
    IUser,
    USER_ICON_MAP,
    UserType,
} from '@models';
import {
    ODataFilterProperty,
    ODataQueryOptions,
} from '@services/generics/odata.query';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

import { map } from 'rxjs/operators';

export const DEFAULT_NOTIFICATION_SETTINGS: INotificationSettings = {
    transactions: true,
    robots: true,
    jobs: true,
    tasks: true,
    schedules: true,
    queues: true,
};

@Injectable({
    providedIn: 'root',
})
export class UserService extends ODataService<IUser, number> {
    protected _endpoint: string;

    constructor(
        http: HttpClient,
    ) {
        super(http, MapperService.userMap);
        this._endpoint = '/odata/Users';
    }

    public importUsers(data: any) {
        data.group = (data.group || '').trim();
        const payload = JSON.stringify(data);
        return this._http.post(`${this._endpoint}/UiPath.Server.Configuration.OData.ImportUsers`, payload);
    }

    public changePassword(userId: number, data: any) {
        const payload = JSON.stringify(this._toPoco(data, MapperService.changePasswordMap));
        return this._http
            .post(`${this._endpoint}(${userId})/UiPath.Server.Configuration.OData.ChangePassword`, payload);
    }

    public setActive(userId: number, active: boolean) {
        const payload = JSON.stringify({ active });
        return this._http.post(
            `${this._endpoint}(${userId})/UiPath.Server.Configuration.OData.SetActive`,
            payload,
        );
    }

    public suggest = (searchTerm?: string, fetchSize = 20, skip: number = 0, type?: UserType) => {
        const queryOptions: ODataQueryOptions = {
            select: ['UserName', 'Id', 'Type', 'RolesList'],
            orderBy: ['Type', 'UserName'],
            top: fetchSize,
            skip,
        };

        if (searchTerm != null) {
            queryOptions.filter = {
                UserName: {
                    contains: searchTerm,
                },
            };
        }

        if (type != null) {
            queryOptions.filter = {
                ...queryOptions.filter as ODataFilterProperty,
                Type: {
                    eq: UserType[type],
                },
            };
        }

        return this
            .get(queryOptions)
            .pipe(
                map(
                    ({ data, total }) =>
                        ({
                            total,
                            data: data.map(user => ({
                                id: user.id,
                                text: user.userName,
                                icon: USER_ICON_MAP[user.type],
                            })),
                        }),
                ),
            );
    }
}
